/* tru-link-params.js (Oct 1 2026): carry landing-page tracking params (fbclid, utm_*, gclid, ...) onto links to tru-cbn.com.
   Never overwrites a param the link already has. Params are kept in sessionStorage for this tab. Rollback: remove the script tag in layout/theme.liquid. */
(function () {
  'use strict';
  var KEY = 'tru_landing_params_v1';
  var TARGET = /(^|\.)tru-cbn\.com$/i;
  var NAMED = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'dclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id', 'epik', 'sccid', 'rdt_cid', 'irclickid', 'mc_cid', 'mc_eid', '_kx'];
  function isTracking(k) { k = String(k).toLowerCase(); return k.indexOf('utm_') === 0 || NAMED.indexOf(k) !== -1; }
  function readStore() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function writeStore(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  // Capture: a page view that carries tracking params replaces the stored set (it is the newest landing).
  var fresh = [];
  try {
    new URLSearchParams(window.location.search).forEach(function (v, k) { if (isTracking(k) && v !== '') fresh.push([k, v]); });
  } catch (e) {}
  var params = fresh.length ? fresh : (readStore() || []);
  if (fresh.length) writeStore(fresh);
  if (!params.length) return;


  // Oct 21 2026 (Otto): /go/<name> links are trytrucbn URL redirects to tru-cbn.com (they avoid Shopify's leave-site warning).
  // Shopify redirects keep the redirect's own params on conflict, so when the visitor has landing params we point the link at
  // /go/t/<name> (same destination, no UTMs / no return_to) and add the merged params ourselves: redirect defaults, overridden by the visitor's utm_*, plus click IDs.
  // No landing params = link untouched, so /go/<name> keeps its built-in defaults.
  var GO = /^\/go\/(?!t\/)([a-z0-9-]+)\/?$/i;
  function goDecorate(a, u) {
    var m = GO.exec(u.pathname); if (!m) return false;
    var name = m[1].toLowerCase(), cart = /^(.+)-(90day|monthly|onetime)$/.exec(name);
    var campaign = cart ? cart[1] : (/-faq$/.test(name) ? 'faq' : 'home');
    // Oct 22 2026 (Sacha-approved): landing params first, then force try-page UTMs; keep the ad's utm_source in utm_content (or ad_source).
    var q = new URLSearchParams();
    for (var i = 0; i < params.length; i++) q.set(params[i][0], params[i][1]);
    var adSrc = q.get('utm_source'), adCamp = q.get('utm_campaign');
    // Oct 28 2026 (Sacha-approved 7:59 AM PT): keep the ad's utm_campaign (e.g. scale_oct26); page label only when the visitor has none. Page label always rides in lp.
    q.set('utm_source', 'trytrucbn'); q.set('utm_medium', 'lp'); q.set('utm_campaign', adCamp || campaign);
    if (adSrc && adSrc.toLowerCase() !== 'trytrucbn') { if (!q.get('utm_content')) q.set('utm_content', adSrc); else q.set('ad_source', adSrc); }
    var out = new URL('/go/t/' + name, window.location.origin);
    q.set('lp', campaign);
    if (cart) { out.searchParams.set('return_to', '/cart?' + q.toString()); }
    else out.search = q.toString();
    out.hash = u.hash;
    if (a.href !== out.toString()) a.href = out.toString();
    return true;
  }
  function decorate(a) {
    if (!a || !a.href) return;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (e) { return; }
    if (/^https?:$/.test(u.protocol) && u.origin === window.location.origin && goDecorate(a, u)) return;
    if (!/^https?:$/.test(u.protocol) || !TARGET.test(u.hostname)) return;
    var changed = false;
    for (var i = 0; i < params.length; i++) {
      if (!u.searchParams.has(params[i][0])) { u.searchParams.append(params[i][0], params[i][1]); changed = true; }
    }
    if (changed) a.href = u.toString();
  }
  function decorateAll(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll('a[href]') : [];
    for (var i = 0; i < list.length; i++) decorate(list[i]);
  }
  function onClick(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (a) decorate(a);
  }
  document.addEventListener('pointerdown', onClick, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') onClick(e); }, true);
  function start() {
    decorateAll(document);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes') { decorate(m.target); continue; }
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'A') decorate(n); else decorateAll(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
